module.exports = __webpack_public_path__ + "img/1510176097.b2ae3dc2.jpg";